import React from 'react';
import { Box, Typography } from '@mui/material';
import { Apps } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import NavigationCard from './NavigationCard';
import { navigationItems, complianceNavigationItem } from './navigation/navigationConfig';
import { useFeatureFlag } from '../../../utils/featureFlags';

/**
 * NavigationSection - Renders module navigation cards in a responsive grid
 */
const NavigationSection: React.FC = () => {
  const navigate = useNavigate();
  const complianceEnabled = useFeatureFlag('Compliance');
  const items = complianceEnabled ? [...navigationItems, complianceNavigationItem] : navigationItems;

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <Apps sx={{ color: '#64748b', fontSize: '1.25rem' }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b' }}>
          Modules
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)'
          },
          gap: 3
        }}
      >
        {items.map(item => (
          <NavigationCard
            key={item.path}
            title={item.title}
            description={item.description}
            icon={item.icon}
            color={item.color}
            onClick={() => navigate(item.path)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default NavigationSection;
